export interface OriginLocationRef {
  locationId?: string | null;
  name?: string | null;
}

export interface InventoryLevelLocation {
  /** The location's canonical external id, which inventory sources report against. */
  locationKey?: string | null;
  locationName?: string | null;
}

/**
 * Whether an inventory level is at a fulfillment group's origin. Keyed on the
 * origin's location id: names differ between systems and stop matching the
 * moment a source names a location its own way or a marketplace sends the
 * street as the name. The name only settles an origin that carries no id, or
 * a level from an inventory server that predates `locationKey`.
 */
export function inventoryLevelAtOrigin(
  origin: OriginLocationRef,
  level: InventoryLevelLocation,
): boolean {
  if (origin.locationId && level.locationKey !== undefined) {
    return level.locationKey === origin.locationId;
  }
  return !!origin.name && level.locationName === origin.name;
}
